import { isPlatformServer } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { from, Observable } from "rxjs";

declare const AwsWafIntegration: AwsIntegrationsObject;

interface AwsIntegrationsObject {
    getToken(): Promise<string>;
    hasToken(): boolean;
}

@Injectable({
    providedIn: 'root'
})
export class AwsWafTokenService {
    public getToken(): Observable<string> {
        if(isPlatformServer(this.platformId)) {
            throw new Error("AwsWafTokenService.getToken() should not be called on the server side.");
        }

        return from(AwsWafIntegration.getToken());
    }

    public hasToken(): boolean {
        return AwsWafIntegration.hasToken();
    }

    constructor(@Inject(PLATFORM_ID) private platformId: any) {
    }
}